import {
    GET_LIST_PHIKHACHANGKY,
    GET_LIST_PHIKHACHANGKY_SUCCESS,
    GET_LIST_PHIKHACHANGKY_FAILURE,
    GET_LIST_PHIKHACHANGKY_CHOVAY,
    GET_LIST_PHIKHACHANGKY_CHOVAY_SUCCESS,
    GET_LIST_PHIKHACHANGKY_CHOVAY_FAILURE,
  } from "./actionTypes";
  
  export const getListPhiKhacHangKy = (dataSearch) => ({
    type: GET_LIST_PHIKHACHANGKY,
    dataSearch,
  });
  
  export const getListPhiKhacHangKySuccess = (data) => ({
    type: GET_LIST_PHIKHACHANGKY_SUCCESS,
    payload: data,
  });
  
  export const getListPhiKhacHangKyFailure = () => ({
    type: GET_LIST_PHIKHACHANGKY_FAILURE,
  });
  
  export const getListPhiKhacHangKyTheoChoVay = (dataSearch) => ({
    type: GET_LIST_PHIKHACHANGKY_CHOVAY,
    dataSearch,
  });
  
  export const getListPhiKhacHangKyTheoChoVaySuccess = (data) => ({
    type: GET_LIST_PHIKHACHANGKY_CHOVAY_SUCCESS,
    payload: data,
  });
  
  export const getListPhiKhacHangKyTheoChoVayFailure = () => ({
    type: GET_LIST_PHIKHACHANGKY_CHOVAY_FAILURE,
  });
  